var _rect, _text, _path, _ellipse, _circle, _path2, _text2, _rect2, _text3, _path3, _ellipse2, _path4, _text4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVsMindfulness(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 60,
    width: 150,
    height: 160,
    rx: 12,
    stroke: "#38bdf8",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 88,
    fill: "#38bdf8",
    fontFamily: "system-ui,sans-serif",
    fontSize: 13,
    fontWeight: 700
  }, "NOTICE")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 175 Q115 110 115 110 Q115 110 145 175 Z",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 115,
    cy: 140,
    rx: 18,
    ry: 14,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 135,
    r: 3,
    fill: "#fafcfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70 195 L160 195",
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.3
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 78,
    y: 210,
    fill: "#fafcfb",
    fontFamily: "system-ui,sans-serif",
    fontSize: 9,
    opacity: 0.6
  }, "Awareness")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 210,
    y: 60,
    width: 150,
    height: 160,
    rx: 12,
    stroke: "#fbbf24",
    strokeWidth: 2
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 248,
    y: 88,
    fill: "#fbbf24",
    fontFamily: "system-ui,sans-serif",
    fontSize: 13,
    fontWeight: 700
  }, "DECIDE")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M255 175 Q285 110 285 110 Q285 110 315 175 Z",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 285,
    cy: 140,
    rx: 18,
    ry: 14,
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M268 135 L278 145 L298 125",
    stroke: "#fafcfb",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 248,
    y: 210,
    fill: "#fafcfb",
    fontFamily: "system-ui,sans-serif",
    fontSize: 9,
    opacity: 0.6
  }, "Structured thinking")), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M195 130 L210 130 M205 125 L210 130 L205 135",
    stroke: "#38bdf8",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVsMindfulness);
export default __webpack_public_path__ + "static/media/vs-mindfulness.5b082edfb8de94cab038cdba740f1c7c.svg";
export { ForwardRef as ReactComponent };